<template>
  <div class="modal fade" id="VoirDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="voirDetailsRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Détail des arrièrés de l'emplacement</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  N° place <span class="text-danger"></span> :
                  {{ contrat.nouveauCode }}
                </label>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Ancien n° <span class="text-danger"></span> :
                  {{ contrat.ancienCode }}
                </label>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Secteur <span class="text-danger"></span> :
                  {{ contrat.secteur }}
                </label>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Numéro Compte <span class="text-danger"></span> :
                  {{ contrat.numCompte }}
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Année</th>
                      <th>Taux</th>
                      <th>Mois</th>
                      <th>Montant</th>
                      <th>Statu</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(arr, index) in arrieres" :key="index">
                      <td>{{ arr.annee }}</td>
                      <td>{{ arr.taux }}</td>
                      <td>{{ arr.mois }}</td>
                      <td>{{ arr.montant }}</td>
                      <td>
                        <span v-if="arr.montant == 0" class="badge text-outline-primary">Soldé</span>
                        <span v-else class="badge text-outline-danger">En attente</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import { Option } from "@/models/Option";
import { hideModal, showModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios from "axios";
import ApiService from "@/services/ApiService";

export default defineComponent({
  name: "ElementVue",
  components: {
    // Form,
    // Field,
    // ErrorMessage,
    // Multiselect,
  },
  props: {
    item: {
      type: Number,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const voirDetailsRef = ref<null | HTMLElement>(null);
    const locataire = ref("");
    const numCompte = ref("");
    const emplace = ref("");
    const taux = ref();
    const contratId = ref();
    const contrat = ref<any>({});
    const arrieres = ref<Array<any>>([]);

    const recupereContrat = async (id: number) => {
      try {
        const response = await axios.get(`/contrat/new/arrieres/${id}`);
        const donneee = response.data.data;
        contrat.value = {
          id: donneee[0].id,
          locataire: donneee[0].locataire,
          numCompte: donneee[0].num_compte,
          nouveauCode: donneee[0].ncode_emp,
          taux: donneee[0].taux,
          ancienCode: donneee[0].codeemp,
          marche: donneee[0].marche,
          zone: donneee[0].zone,
          secteur: donneee[0].libelle_secteur,
          valide: donneee[0].valide,
          nombreArriere: donneee.length,
        };

        arrieres.value = donneee.map((don) => ({
          id: don.arr_id,
          annee: don.arr_annee,
          mois: don.arr_mois,
          taux: don.arr_taux,
          reste: don.arr_resteApayer,
          montant: don.arr_montnat_arr,
          valide: don.arr_valide,
        }));

        locataire.value = donneee[0].locataire;
        emplace.value = donneee[0].ncode_emp;
        numCompte.value = donneee[0].num_compte;
        taux.value = donneee[0].loyer;
        contratId.value = donneee[0].id;
      } catch (error) {
        //
      }
    };
    const idContrat = ref();
    watch(
      () => props.item,
      async (newValue) => {
        if (newValue) {
          idContrat.value = newValue;
          await recupereContrat(newValue);
        }
      }
    );
    const soumission = async () => {
      var values = {};
      values["contrats"] = [idContrat.value];
      // values["secteur"] = secteur.value;
      values["etat"] = false;
      await ApiService.post("/validation", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            hideModal(voirDetailsRef.value);
            emit("close");
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };
    return {
      props,
      recupereContrat,
      soumission,
      contrat,
      arrieres,
      voirDetailsRef,
    };
  },
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>